import { useState } from "react";
import { fetchCnpjData } from "../../Services/cnpjService";
import { useTranslation } from "react-i18next";
import { validateCpfCnpj } from "../../Helpers/Form";

export function useCnpjLookup({ onSuccess, onError }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const lookup = async (cnpj) => {
        if (!cnpj || cnpj.trim() === "") {
            const errorMsg = t("validation.cnpj_required");
            setError(errorMsg);
            onError?.(errorMsg);
            return;
        }

        // Verifica se o CNPJ tem o formato correto (14 dígitos)
        if (!validateCpfCnpj(cnpj, true)) {
            const errorMsg = t("client.form.error.cnpj.invalid");
            setError(errorMsg);
            onError?.(errorMsg);
            return;
        }

        setLoading(true);
        setError(null);
        try {
            const data = await fetchCnpjData(cnpj);
            onSuccess?.(data);
        } catch (err) {
            console.error("Error fetching CNPJ data:", err);
            let errorMsg = t("client.form.error.cnpj.message");

            if (err instanceof Error) {
                // Mapear erros específicos
                if (
                    err.message.includes("404") ||
                    err.message.includes("not found")
                ) {
                    errorMsg = t("client.form.error.cnpj.not_found");
                } else if (err.message.includes("timeout")) {
                    errorMsg = t("client.form.error.cnpj.timeout");
                }
            }

            setError(errorMsg);
            onError?.(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return { lookup, loading, error };
}
